import { useState } from "react";
import EmailNotification from "./Sections/emailNotification/Email Notifications";
import OtherTravellers from "./Sections/otherTravellers/OtherTravellers";
import PaymentDetails from "./Sections/paymentDetails/PaymentDetails";
import PersonalDetails from "./Sections/Personal-Details/PersonalDetails";
import Preferences from "./Sections/preferences/Preferences";
import PrivacySection from "./Sections/Privacy/Privacy";
import Security from "./Sections/security/Security";
import UserProfileSidebar from "./userProfile.sidebar";
import Header from "../../components/Header/Header-main";
const MainProfilePage = () => {
  const [activeComponent, setActiveComponent] = useState("PersonalDetails");

  const renderComponent = () => {
    switch (activeComponent) {
      case "PersonalDetails":
        return <PersonalDetails />;
      case "Preferences":
        return <Preferences />;
      case "Security":
        return <Security />;
      case "PaymentDetails":
        return <PaymentDetails />;
      case "PrivacySection":
        return <PrivacySection />;
      case "EmailNotification":
        return <EmailNotification />;
      case "OtherTravellers":
        return <OtherTravellers />;
      default:
        return <PersonalDetails />;
    }
  };

  return (
    <>
      {/* <Header/> */}
      <div className="flex flex-row font-hk">
        <UserProfileSidebar setActiveComponent={setActiveComponent} />
        <div className="flex flex-col ml-10">{renderComponent()}</div>
      </div>
    </>
  );
};

export default MainProfilePage;
